// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Enum for permission mode values.
 */
export enum PermissionMode {
  /** Permission not valid. */
  None = "none",
  /** Permission applicable for read operations only. */
  Read = "read",
  /** Permission applicable for all operations. */
  All = "all",
}
